import { DataGridProvider as DataGridProviderPackage } from '@chipinside/datagrid'
import { PropsWithChildren, useState } from 'react'
import { toast } from 'sonner'

import { defaultDrawerOptions, DrawerComponent } from '#/components/Drawer'
import FormatCell, { FormatCellTypes } from '#/components/FormatCell'
import LinearLoader from '#/components/Loader/Linear'
import PageError from '#/pages/Fallback/PageError'
import { useUserInfo } from '#/store/ducks/auth'
import { useFarmName } from '#/store/ducks/farm'
import { listeners } from '#/utils/listeners'

export function DatagridProvider({ children }: PropsWithChildren) {
  const exportName = useFarmName()
  const user = useUserInfo()
  const [drawerOptions, setDrawerOptions] = useState({ open: false })

  return (
    <DataGridProviderPackage
      constants={{
        exportName,
        // Permite o dev mode do datagrid apontar se o `type` da coluna tem renderer registrado
        // Talvez depois passar FormatCellTypes (objeto) somente e eliminar o "FormatCell" como componente?
        formatCellTypes: Object.keys(FormatCellTypes),
        listener: listeners.datagrid,
        locale: (user as any)?.locale,
      }}
      components={{
        FormatCell: props => <FormatCell {...props} />,
        Loader: props => <LinearLoader {...props} />,
        PageError: props => <PageError {...props} />,
      }}
      functions={{
        openDrawer: props => setDrawerOptions(props),
        toast,
      }}
    >
      {children}
      <DrawerComponent
        options={{ ...defaultDrawerOptions, ...drawerOptions }}
        onClose={() => setDrawerOptions({ open: false })}
      />
    </DataGridProviderPackage>
  )
}
